import { ActionTree } from 'vuex'
import { TechpacksState } from './techpacks.model'
import { MutationTypes } from './techpacks.mutations'
import { authenticatedApolloClient } from '@/services/authenticated-apollo.service'
import getSharedFolderById from '@/graphql/queries/getSharedFolderById'
import folderDetailsDataMapper from './mapper'
import arrayToDict from '@/utils/array-to-dictionary'
import { GetSharedFolderByIdQuery, GetSharedFolderByIdQueryVariables } from '@/graphql/generated/types'

export const actions: ActionTree<TechpacksState, unknown> = {
  async GET_TECHPACKS({ commit }, { id, company }: { id: string; company: string }) {
    commit(MutationTypes.GET_TECHPACKS_REQUEST)
    try {
      const {
        data: { getSharedFolderById: folderDetails }
      } = await authenticatedApolloClient.query<GetSharedFolderByIdQuery, GetSharedFolderByIdQueryVariables>({
        query: getSharedFolderById,
        variables: {
          id,
          company
        },
        errorPolicy: 'all'
      })
      if (folderDetails?.techpacks?.length) {
        const folderTechpacks = folderDetailsDataMapper(folderDetails)
        const dictionary = arrayToDict(folderTechpacks, 'folderId')
        commit(MutationTypes.GET_TECHPACKS_SUCCESS, dictionary)
      } else if (folderDetails && !folderDetails.techpacks?.length) {
        commit(MutationTypes.GET_TECHPACKS_SUCCESS, {})
      } else {
        commit(MutationTypes.GET_TECHPACKS_FAILURE, 'An unexpected error occurred getting the techpacks in this folder')
      }
    } catch (err) {
      commit(MutationTypes.GET_TECHPACKS_FAILURE, 'An unexpected error occurred getting the techpacks in this folder')
    }
  }
}
